import { render, staticRenderFns } from "./addRootCategoryl.vue?vue&type=template&id=611ac892&scoped=true"
import script from "./addRootCategoryl.vue?vue&type=script&lang=js"
export * from "./addRootCategoryl.vue?vue&type=script&lang=js"
import style0 from "./addRootCategoryl.vue?vue&type=style&index=0&id=611ac892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611ac892",
  null
  
)

export default component.exports